import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../ui/dialog";
import { Button } from "../../ui/button";
import { DialogDescription } from "@radix-ui/react-dialog";

const DeleteModal = ({
  onOpenChange,
  open,
  children,
  title,
  data,
  id,
  handleDelete,
  loading
}) => {
  const onSubmit = () => {
    handleDelete(id);
    // handleModal()
  };

  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="p-6 bg-white">
        <DialogHeader className="bg-white py-2 rounded-lg">
          <DialogTitle className="text-left md:px-4 py-2">
            {title}
          </DialogTitle>
          <p className="border border-neutral300 w-full"></p>
          <DialogDescription className="py-2 text-[16px] text-left text-neutral800 md:px-4">
            Are you sure you want to delete <span className="break-all"><b>{data}</b>?</span> You won't be able to
            revert this action.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex flex-row gap-2 items-center justify-end">
          <Button
            onClick={() => onOpenChange(false)}
            type="submit"
            variant={"outline"}
            className="text-base text-black px-4 py-2 border border-black bg-white hover:bg-neutral100"
          >
            Cancel
          </Button>
          <Button onClick={onSubmit} loading={loading} type="submit" className=" text-base text-white bg-error400 hover:bg-[#f85d86] px-4 py-2">
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteModal;
